import * as z from 'zod';
import { isValid } from '@pages/Client/Calendar/components/BulkEdit/helpers/isValidValidationNumber';

export const numberOrNan = z.union([z.number(), z.nan()]);
export const isPositive = (value?: number | null) => (isValid(value) ? Number(value) >= 0 : true);
